var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "page-login" }, [
    _vm._m(0),
    _vm._v(" "),
    _c("section", { staticClass: "login" }, [
      _c("div", { staticClass: "content" }, [
        _c("div", { staticClass: "login-form" }, [
          _c("h1", [_vm._v(_vm._s(_vm.trans("auth.account_activation")))]),
          _vm._v(" "),
          _vm.status
            ? _c("h4", { domProps: { textContent: _vm._s(_vm.message) } })
            : _c("h4", {
                staticStyle: { color: "#ff0000" },
                domProps: { textContent: _vm._s(_vm.message) },
              }),
          _vm._v(" "),
          _c("br"),
          _vm._v(" "),
          _c(
            "p",
            [
              _vm._v(_vm._s(_vm.trans("auth.back_to_login?")) + " "),
              _c(
                "router-link",
                { staticClass: "text-info m-l-5", attrs: { to: "/login" } },
                [_c("b", [_vm._v(_vm._s(_vm.trans("auth.sign_in")))])]
              ),
            ],
            1
          ),
        ]),
        _vm._v(" "),
        _vm._m(1),
        _vm._v(" "),
        _c("div", { staticClass: "clear" }),
      ]),
    ]),
  ])
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("header", [
      _c("div", { staticClass: "content" }, [
        _c("a", { attrs: { href: "/" } }, [
          _c("img", {
            staticClass: "header-logo",
            attrs: { src: "/images/logo.svg" },
          }),
        ]),
        _vm._v(" "),
        _c(
          "a",
          { staticClass: "header-button-si", attrs: { href: "/register" } },
          [_vm._v("Sign Up")]
        ),
      ]),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "login-hiw" }, [
      _c("h2", [_vm._v("Here’s how it works")]),
      _vm._v(" "),
      _c("ul", [
        _c("li", [
          _c("i", [_vm._v("1")]),
          _c("h3", [_vm._v("Complete our first questionnaire")]),
          _c("p", [
            _vm._v(
              "Tell us more about your investor preferences and your investment offering"
            ),
          ]),
        ]),
        _vm._v(" "),
        _c("li", [
          _c("i", [_vm._v("2")]),
          _c("h3", [_vm._v("Get some free, suitable investor insights")]),
          _c("p", [_vm._v("based on the information submitted")]),
        ]),
        _vm._v(" "),
        _c("li", [
          _c("i", [_vm._v("3")]),
          _c("h3", [_vm._v("Book a video call with one of our experts")]),
          _c("p", [
            _vm._v("Our team will review your offering and give you a quote"),
          ]),
        ]),
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "clear" }),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }